
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { ChatInterface, ProfileMapInterface } from '@/services/QC-V2/chat/interfaces';

@Component({
  mixins: [
    Themeable,
  ],
})
export default class ChatDetails extends Vue {
  @Prop() private chat!: ChatInterface;
  @Prop({ default: false }) private initiallyCollapsed!: boolean;

  private rates: string[] = ['Not Rated', 'Rated Bad', 'Rated Good'];

  private collapsed: boolean = true;

  private hbGroupsMap: string[] = [
    'No Group',
    'Top 50 Biggest Spenders',
    'VIP',
    'Special',
    'Be careful',
    'Super Affiliate',
  ];

  private created(): void {
    this.collapsed = this.initiallyCollapsed;
  }
}
